export default __webpack_public_path__ + "static/media/ganzkoerper-reward-hero.7d608f32.jpg";